import React, { type FC } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import BaseTransitionSlideLeft from '@/base/Transition/SlideLeft';
import LayoutFooter from '@/registration/component/Register/Layout/Footer';
import { UiButton, UiHStack, UiIconCaretLeft, UiIconCaretRight, UiStack } from '@/lib/ui';
import TicketList from '../GroupMainTickets/TicketList';
import { TicketType } from '@/api/constant';
import QueryContainer, { StandardSpinner } from '@/base/QueryContainer/QueryContainer';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { useGroupRegistrationQuery } from '@/registration/hook/useGroupRegistrationQuery';
import { useRegisterGroupSteps } from '@/registration/hook/useRegisterGroupSteps';
import GroupHeader from '@/registration/component/Register/Layout/GroupHeader';
import { useEventSettingsQuery } from '@/registration/hook/useEventSettingsQuery';
import InfoBox from '@/registration/component/InfoBox';
import BaseThemeButton from '@/base/ThemeButton';
import BrandFooter from '@/registration/component/Register/Layout/BrandFooter';

const MainTickets: FC = () => {
  const { eventId } = useRegisterRoute();
  const { data: eventSetting } = useEventSettingsQuery(eventId);
  const groupRegistrationQuery = useGroupRegistrationQuery(eventId);
  const { toNextStep, toPreviousStep } = useRegisterGroupSteps();

  return (
    <RegisterLayout header={<GroupHeader />}>
      <QueryContainer query={groupRegistrationQuery} loadingComponent={<StandardSpinner />}>
        {(groupRegistration) => {
          return (
            <>
              <BaseTransitionSlideLeft>
                <UiStack flexGrow={1} spacing={8}>
                  <InfoBox
                    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                    title={eventSetting?.pageMetadata?.workshopTicket?.title || 'Workshop tickets'}
                    description={eventSetting?.pageMetadata?.workshopTicket?.description}
                  />
                  <TicketList ticketType={TicketType.Workshop} onEmpty={toNextStep} groupRegistration={groupRegistration} />
                </UiStack>
              </BaseTransitionSlideLeft>
              <UiStack height={96} />
              <LayoutFooter isGroup>
                <UiHStack justifyContent={'space-between'} flexGrow={1}>
                  <BaseThemeButton
                    theme={'gray'}
                    onClick={toPreviousStep}
                    leftIcon={(
                      <UiIconCaretLeft color={'primary.800'} size={'lg'} weight={'bold'}/>
                    )}
                  >
                    Prev
                  </BaseThemeButton>
                  <BrandFooter/>
                  <BaseThemeButton
                    theme={'primary'}
                    onClick={toNextStep}
                    rightIcon={(
                      <UiIconCaretRight color={'primary.800'} size={'lg'} weight={'bold'}/>
                    )}
                  >
                    Next
                  </BaseThemeButton>

                  {/*<UiButton*/}
                  {/*  size={'lg'}*/}
                  {/*  colorScheme={'primary'}*/}
                  {/*  onClick={toPreviousStep}*/}
                  {/*  variant={'ghost'}*/}
                  {/*  fontSize={'lg'}*/}
                  {/*  leftIcon={(*/}
                  {/*    <UiIconCaretLeft color={'primary.800'} size={'xl'} weight={'bold'}/>*/}
                  {/*  )}*/}
                  {/*>*/}
                  {/*  Previous*/}
                  {/*</UiButton>*/}
                  {/*<UiButton*/}
                  {/*  size={'lg'}*/}
                  {/*  colorScheme={'primary'}*/}
                  {/*  onClick={toNextStep}*/}
                  {/*  variant={'ghost'}*/}
                  {/*  fontSize={'lg'}*/}
                  {/*  rightIcon={(*/}
                  {/*    <UiIconCaretRight color={'primary.800'} size={'xl'} weight={'bold'}/>*/}
                  {/*  )}*/}
                  {/*>*/}
                  {/*  Next*/}
                  {/*</UiButton>*/}
                </UiHStack>
              </LayoutFooter>
            </>
          );
        }}
      </QueryContainer>
    </RegisterLayout>
  );
};

export default MainTickets;
